import React from "react"
import cx from "classnames"
import classes from "./styles.module.scss"

interface Props {
	videoURL: string
}

const Video:React.FC<Props> = ({videoURL}) => {
	if (!videoURL) {
		return null
	}
	return (
		<>
		<div className={cx(classes.Overlay)}/>
            <video autoPlay="autoplay" loop="loop" muted className={classes.Video} >
                <source src={videoURL} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
						</>
	)
}

export default Video